var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-number-container",class:_vm.myclass},[_c('div',{staticClass:"l-number"},[_vm._v(" "+_vm._s(_vm.current)+"/"+_vm._s(_vm.total)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }